import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { subPageRef } from './consts';

export default grapesjs.plugins.add('zerocode-subpage', (editor, opts = {}) => {
  let defaults = {
    blocks: [subPageRef],
    labelSubPageCategory: 'Advanced',
    labelSubPage: 'Sub Page',
    pfx: 'subPage',
  };

  for (let name in defaults) {
    if (!(name in opts)) opts[name] = defaults[name];
  }

  loadComponents(editor, opts);
  loadBlocks(editor, opts);
});
